/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/** Global user role */
export var RemoveUserRoleParamsRoleEnum;
(function (RemoveUserRoleParamsRoleEnum) {
    RemoveUserRoleParamsRoleEnum["AUTHORITY_ADMIN"] = "AUTHORITY_ADMIN";
    RemoveUserRoleParamsRoleEnum["USER_ADMIN"] = "USER_ADMIN";
    RemoveUserRoleParamsRoleEnum["VOCABULARY_ADMIN"] = "VOCABULARY_ADMIN";
    RemoveUserRoleParamsRoleEnum["USER"] = "USER";
})(RemoveUserRoleParamsRoleEnum || (RemoveUserRoleParamsRoleEnum = {}));
/** Global user role */
export var RemoveUserRoleParamsEnum;
(function (RemoveUserRoleParamsEnum) {
    RemoveUserRoleParamsEnum["AUTHORITY_ADMIN"] = "AUTHORITY_ADMIN";
    RemoveUserRoleParamsEnum["USER_ADMIN"] = "USER_ADMIN";
    RemoveUserRoleParamsEnum["VOCABULARY_ADMIN"] = "VOCABULARY_ADMIN";
    RemoveUserRoleParamsEnum["USER"] = "USER";
})(RemoveUserRoleParamsEnum || (RemoveUserRoleParamsEnum = {}));
/** User account status */
export var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["ACTIVE"] = "ACTIVE";
    UserStatusEnum["INACTIVE"] = "INACTIVE";
})(UserStatusEnum || (UserStatusEnum = {}));
/** Global user role */
export var UserRoleRoleEnum;
(function (UserRoleRoleEnum) {
    UserRoleRoleEnum["AUTHORITY_ADMIN"] = "AUTHORITY_ADMIN";
    UserRoleRoleEnum["USER_ADMIN"] = "USER_ADMIN";
    UserRoleRoleEnum["VOCABULARY_ADMIN"] = "VOCABULARY_ADMIN";
    UserRoleRoleEnum["USER"] = "USER";
})(UserRoleRoleEnum || (UserRoleRoleEnum = {}));
/** Authority type specific role */
export var UserRoleAuthorityTypeRoleEnum;
(function (UserRoleAuthorityTypeRoleEnum) {
    UserRoleAuthorityTypeRoleEnum["CATALOGER"] = "CATALOGER";
    UserRoleAuthorityTypeRoleEnum["CATALOGING_SUPERVISOR"] = "CATALOGING_SUPERVISOR";
})(UserRoleAuthorityTypeRoleEnum || (UserRoleAuthorityTypeRoleEnum = {}));
/** Authority type specific role */
export var AuthorityTypeRoleAssignmentRequestRoleEnum;
(function (AuthorityTypeRoleAssignmentRequestRoleEnum) {
    AuthorityTypeRoleAssignmentRequestRoleEnum["CATALOGER"] = "CATALOGER";
    AuthorityTypeRoleAssignmentRequestRoleEnum["CATALOGING_SUPERVISOR"] = "CATALOGING_SUPERVISOR";
})(AuthorityTypeRoleAssignmentRequestRoleEnum || (AuthorityTypeRoleAssignmentRequestRoleEnum = {}));
/** NK role of an authority type role assignment */
export var UserRoleAuthorityTypeNkRoleEnum;
(function (UserRoleAuthorityTypeNkRoleEnum) {
    UserRoleAuthorityTypeNkRoleEnum["CATALOGER"] = "CATALOGER";
    UserRoleAuthorityTypeNkRoleEnum["LOCAL_SUPERVISOR"] = "LOCAL_SUPERVISOR";
    UserRoleAuthorityTypeNkRoleEnum["NK_SUPERVISOR"] = "NK_SUPERVISOR";
})(UserRoleAuthorityTypeNkRoleEnum || (UserRoleAuthorityTypeNkRoleEnum = {}));
/** NK role to assign */
export var AuthorityTypeRoleAssignmentRequestNkRoleEnum;
(function (AuthorityTypeRoleAssignmentRequestNkRoleEnum) {
    AuthorityTypeRoleAssignmentRequestNkRoleEnum["CATALOGER"] = "CATALOGER";
    AuthorityTypeRoleAssignmentRequestNkRoleEnum["LOCAL_SUPERVISOR"] = "LOCAL_SUPERVISOR";
    AuthorityTypeRoleAssignmentRequestNkRoleEnum["NK_SUPERVISOR"] = "NK_SUPERVISOR";
})(AuthorityTypeRoleAssignmentRequestNkRoleEnum || (AuthorityTypeRoleAssignmentRequestNkRoleEnum = {}));
/** Organization status */
export var OrganizationStatusEnum;
(function (OrganizationStatusEnum) {
    OrganizationStatusEnum["ACTIVE"] = "ACTIVE";
    OrganizationStatusEnum["INACTIVE"] = "INACTIVE";
})(OrganizationStatusEnum || (OrganizationStatusEnum = {}));
/** Global user role */
export var RoleAssignmentRequestRoleEnum;
(function (RoleAssignmentRequestRoleEnum) {
    RoleAssignmentRequestRoleEnum["AUTHORITY_ADMIN"] = "AUTHORITY_ADMIN";
    RoleAssignmentRequestRoleEnum["USER_ADMIN"] = "USER_ADMIN";
    RoleAssignmentRequestRoleEnum["VOCABULARY_ADMIN"] = "VOCABULARY_ADMIN";
    RoleAssignmentRequestRoleEnum["USER"] = "USER";
})(RoleAssignmentRequestRoleEnum || (RoleAssignmentRequestRoleEnum = {}));
